function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSourceSyngas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    rx: 2,
    style: {
      fill: "#27DFCC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.455 59.658c-6.128-1.312-13.782-2.242-22.546-2.242C34.722 57.416 0 84.514 0 133.21c0 40.648 25.405 71.351 74.735 71.351 9.354 0 17.539-.925 24.03-2.237 7.111-1.442 11.735-8.341 10.361-15.468-1.349-6.971-8.025-11.555-14.997-10.314-4.661.827-9.72 1.345-14.526 1.345-28.794 0-45.728-18-45.728-46.582 0-31.756 19.901-47.213 45.517-47.213 5.446 0 10.361.579 14.723 1.479 7.095 1.462 14.097-2.898 15.895-9.917l.104-.413a12.71 12.71 0 0 0-9.659-15.583zM189.034 57.416c-42.132 0-69.443 31.973-69.443 74.735 0 40.649 24.768 72.62 67.113 72.62 41.708 0 70.08-28.369 70.08-75.157-.001-39.379-23.929-72.198-67.75-72.198zm-.635 121.734c-21.597 0-34.722-19.688-34.722-47.636 0-27.73 12.702-48.478 34.509-48.478 22.232 0 34.511 22.015 34.511 47.636 0 27.731-12.491 48.478-34.298 48.478z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.0701 0 0 .0701 2.988 2.842)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSourceSyngas);
export default __webpack_public_path__ + "static/media/icon-source-syngas.25604cbcde00b4545308e7c43ccc9863.svg";
export { ForwardRef as ReactComponent };